import React from 'react';
import { Box, Typography } from '@mui/material';
import VideoModelCard from './VideoModelCard';
import { ModelSection as ModelSectionType, ModelCard as ModelCardType } from './types';

interface VideoModelSectionProps {
  section: ModelSectionType;
  onModelClick?: (model: ModelCardType) => void;
}

const VideoModelSection: React.FC<VideoModelSectionProps> = ({
  section,
  onModelClick
}) => {
  return (
    <Box sx={{ marginBottom: '24px' }}>
      <Typography
        sx={{
          fontFamily: 'Inter',
          fontWeight: 500,
          fontSize: '16px',
          lineHeight: '100%',
          textTransform: 'capitalize',
          color: '#FFFFFF',
          marginBottom: '16px'
        }}
      >
        {section.title}
      </Typography>

      {/* Grid Layout - 3 Columns */}
      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: {
            xs: '1fr',
            sm: '1fr 1fr',
            lg: 'repeat(3, 448px)'
          },
          gap: '24px',
          width: '100%',
          justifyContent: { xs: 'stretch', lg: 'start' }
        }}
      >
        {section.models.map(model => (
          <VideoModelCard key={model.id} model={model} onClick={onModelClick} />
        ))}
      </Box>
    </Box>
  );
};

export default VideoModelSection;

